import axios from "axios";
import React from "react";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { partner_Admin } from "../../../Configuration/Partner_URL";
import { toast } from "react-toastify";
import SmallLoader from "../../Common/smallLoader";
import { decryptData, encryptData, onlyNumber } from "../../../CommonMethhods/CommonMethods";

function PartnerBankData(props) {
  const storeToken = localStorage.getItem("ssoToken");
  const  partnerDetails= props.partnerDetails;
  const id = props.id;
  const errorMsg = props.errorMsg
  const getPartnerId = props.getPartnerId;
  const [loader, setLoader] = useState(false);
  const [bankDetailsModal, setBankDetailsModal] = useState(false);
  const [bankNameVal, setBankNameVal] = useState("");
  const [accNumVal, setAccNumVal] = useState("");
  const [branchVal, setBranchVal] = useState("");
  const [ifscVal, setIfscVal] = useState("");
  const [accType, setAccType] = useState("")

  const updatePartnerData = async () => {
    setLoader(true);
    let approReq = {
      id: parseInt(id),
      bankName: bankNameVal?.length > 0 ? bankNameVal: partnerDetails?.bankName,
      bankAcNumber: accNumVal?.length > 0 ? accNumVal : partnerDetails?.bankAcNumber,
      branchName: branchVal?.length > 0 ? branchVal : partnerDetails?.branchName,
      ifscCode: ifscVal?.length > 0 ? ifscVal : partnerDetails?.ifscCode,
      bankAcType: accType?.length > 0 ? accType : partnerDetails?.bankAcType

  }
  let payloadApproved = encryptData(JSON.stringify(approReq))
    try {
      const getDetail = await axios.put(partner_Admin.GetPartnerById,
        payloadApproved,
      
        {
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${storeToken}`,
          },
        }
      );
      const res = decryptData(getDetail?.data);
      let decryptedRes = JSON.parse(res);
      if(decryptedRes?.status === 0){

      setBankDetailsModal(false)
      getPartnerId();
      toast.success(decryptedRes?.data?.message)
    }else{
      toast.error(decryptedRes?.data?.message)
    }
      
    } catch (error) {
      console.log(error);
    }
    finally {
      setLoader(false);
    }
  };

  const handleSaveBtn= ()=>{
    updatePartnerData();
    // professionData();
    // getPartnerId();
  };

  

  return (
    <>
      <div className="card-box partner-bank-detail bottom-25">
        <div className="personal-details-top card-title">
          <h3>Bank Details</h3>
          {errorMsg?.length > 0 ? ""
          :
          <span className="icon-Edit" onClick={()=>{setBankDetailsModal(true)}}></span>
  }
        </div>
        <div className="bank-detail-box">
          <div className="bank-detail-boxes-item">
            <p className="item-label">Bank Name</p>
            <span className="item-value">{partnerDetails?.bankName || "-"}</span>
          </div>
          <div className="bank-detail-boxes-item">
            <p className="item-label">Account Number</p>
            <span className="item-value">{partnerDetails?.bankAcNumber || "0"}</span>
          </div>
          <div className="bank-detail-boxes-item">
            <p className="item-label">Account Type</p>
            <span className="item-value">{partnerDetails?.bankAcType || "-"}</span>
          </div>
          <div className="bank-detail-boxes-item">
            <p className="item-label">Branch Name</p>
            <span className="item-value">{partnerDetails?.branchName || "-"}</span>
          </div>
          <div className="bank-detail-boxes-item">
            <p className="item-label">IFSC Code</p>
            <span className="item-value">{partnerDetails?.ifscCode || "-"}</span>
          </div>
        </div>
      </div>

      <Modal
        show={bankDetailsModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        className="per-modal part-bankmodal"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="mb-4 modal-header">
          <Modal.Title id="contained-modal-title-vcenter ">
            {/* <div className="figure-inlac"> */}
            <h2 className="modal-title">Bank Details</h2>
            {/* </div> */}
          </Modal.Title>
          {/* <button type="button" className="btn-close" aria-label="Close"> */}
          <span className="icon-close" onClick={()=>{setBankDetailsModal(false)}}></span>
          {/* </button> */}
        </Modal.Header>
        <Modal.Body>
          <div>
            {/* <form> */}
              <div className="row">
                <div className="col-md-12 col-12">
                  <div className="form-group">
                    <label className="form-label">Bank Name</label>
                    <input
                      type="text"
                      name="search-text"
                      className="input-st"
                      placeholder="Bank Name"
                      autoComplete="off"
                      onChange={(e)=> setBankNameVal(e?.target?.value)}
                      defaultValue={partnerDetails?.bankName ? partnerDetails?.bankName : bankNameVal}
                    />
                  </div>
                </div>
                <div className="col-md-12 col-12">
                  <div className="form-group">
                    <label className="form-label">Account Number</label>
                    <input
                      type="text"
                      name="search-text"
                      maxLength={20}
                      className="input-st"
                      placeholder="Account Number"
                      autoComplete="off"
                      onInput={onlyNumber}
                      onChange={(e)=> setAccNumVal(e?.target?.value)}
                      defaultValue={partnerDetails?.bankAcNumber ? partnerDetails?.bankAcNumber : accNumVal}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-12">
                  <div className="form-group">
                    <label className="form-label">Bank Branch</label>
                    <input
                      type="text"
                      className="input-st"
                      placeholder="Bank Branch"
                      autoComplete="off"
                      onChange={(e)=> setBranchVal(e?.target?.value)}
                      defaultValue={partnerDetails?.branchName ? partnerDetails?.branchName : branchVal}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-12">
                  <div className="form-group">
                    <label className="form-label">IFSC Code</label>
                    <input
                      type="text"
                      name="search-text"
                      className="input-st"
                      placeholder="IFSC Code"
                      autoComplete="off"
                      onChange={(e)=> setIfscVal(e?.target?.value)}
                      defaultValue={partnerDetails?.ifscCode ? partnerDetails?.ifscCode : ifscVal}

                    />
                  </div>
                </div>
                <div className="col-md-12 col-12">
                  <div className="form-group type-select ">
                    <label className="form-label">Account Type</label>
                    <select 
                    type="text"
                    autoComplete="off"
                    onChange={(e)=> setAccType(e?.target?.value)} 
                    defaultValue={partnerDetails?.bankAcType ? partnerDetails?.bankAcType : accType}
                    >

                      <option value="Current" className="opt">Current</option>
                      <option value="Saving" className="opt">Saving</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="savechanges-wrapper">
                <button 
                className="save-changes" 
                type="submit" 
                onClick={()=> handleSaveBtn()}
                >
                  {loader ? 
                  <SmallLoader />
                  : 
                  <>
                    Save Changes
                  </>
                }
              </button>
              </div>
            {/* </form> */}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default PartnerBankData;
